import { render, staticRenderFns } from "./BooleanCheckboxField.vue?vue&type=template&id=451918e0&scoped=true&"
import script from "./BooleanCheckboxField.vue?vue&type=script&lang=ts&"
export * from "./BooleanCheckboxField.vue?vue&type=script&lang=ts&"
import style0 from "./BooleanCheckboxField.vue?vue&type=style&index=0&id=451918e0&lang=scss&scoped=true&"
import style1 from "./BooleanCheckboxField.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451918e0",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
installComponents(component, {VCheckbox})
